import identity from 'lodash/identity';

import { type Beneficiary } from 'modules/invoices/transfer/models';
import {
  type MutationState,
  useMutation,
} from 'src/core/api/hooks/useMutation';

export type Error = {
  error: 'payments-not-found';
};

export type Payload = {
  paymentIds: string[];
};

export type Response = Beneficiary.VerificationResult[];

export const useVerifyInvoiceTransfersBeneficiariesQuery = (): MutationState<
  Payload,
  Response,
  Error
> => {
  return useMutation<Payload, Response, Response, Error>({
    request: {
      type: 'rest',
      target: 'companyAPI',
      endpoint: `/transfer-scheduling/payments/verify-beneficiaries`,
      method: 'post',
    },
    options: {
      throwOnError: true,
    },
    reshapeData: identity,
  });
};
